export const TRANSLATIONS = {
	en: {
		advertisement: 'Advertisement',
		'learn-more': 'Learn More',
	},
	ar: {
		advertisement: 'إعلان',
	},
	bn: {
		advertisement: 'বিজ্ঞাপন',
	},
	br: {
		advertisement: 'Bomm bruderezh',
	},
	ca: {
		advertisement: 'Anunci',
	},
	cs: {
		advertisement: 'Reklama',
	},
	de: {
		advertisement: 'Anzeige',
		'learn-more': 'Erfahre mehr',
	},
	es: {
		advertisement: 'Anuncio',
		'learn-more': 'Conoce más',
	},
	eu: {
		advertisement: 'Iragarkia',
	},
	fa: {
		advertisement: 'تبلیغات',
	},
	fo: {
		advertisement: 'Lýsing',
	},
	fr: {
		advertisement: 'Publicité',
		'learn-more': 'En savoir plus',
	},
	fy: {
		advertisement: 'Advertinsje',
	},
	gl: {
		advertisement: 'Anuncio',
	},
	gv: {
		advertisement: 'Soilsheen',
	},
	he: {
		advertisement: 'פרסומת',
	},
	hu: {
		advertisement: 'Hirdetés',
	},
	id: {
		advertisement: 'Iklan',
		'learn-more': 'Baca Selengkapnya',
	},
	inh: {
		advertisement: 'дебат',
	},
	it: {
		advertisement: 'Pubblicità',
		'learn-more': 'Ulteriori informazioni',
	},
	ja: {
		advertisement: '広告',
		'learn-more': 'もっと見る',
	},
	ko: {
		advertisement: '광고',
	},
	krc: {
		advertisement: 'Pеклама',
	},
	lb: {
		advertisement: 'Reklamm',
	},
	mk: {
		advertisement: 'Pеклама',
	},
	mr: {
		advertisement: 'जाहिरात',
	},
	ms: {
		advertisement: 'Iklan',
	},
	nl: {
		advertisement: 'Advertentie',
		'learn-more': 'Meer te weten komen',
	},
	no: {
		advertisement: 'Reklame',
	},
	pl: {
		advertisement: 'Reklama',
		'learn-more': 'Czytaj więcej',
	},
	ps: {
		advertisement: 'خبرتيا',
	},
	pt: {
		advertisement: 'Anúncio',
		'learn-more': 'Saiba Mais',
	},
	'roa-tara': {
		advertisement: 'Pubblecetà',
	},
	ru: {
		advertisement: 'Pеклама',
		'learn-more': 'Узнать больше',
	},
	si: {
		advertisement: 'ප්‍රචාරක දැන්වීම',
	},
	sl: {
		advertisement: 'Oglas',
	},
	'sr-ec': {
		advertisement: 'Pеклама',
	},
	sv: {
		advertisement: 'Annons',
	},
	te: {
		advertisement: 'వాణిజ్య ప్రకటన',
	},
	th: {
		advertisement: 'การโฆษณา',
	},
	tr: {
		advertisement: 'Reklam',
	},
	'tt-cyrl': {
		advertisement: 'Pеклама',
	},
	uk: {
		advertisement: 'Pеклама',
	},
	vi: {
		advertisement: 'Quảng cáo',
	},
	'zh-hans': {
		advertisement: '广告',
		'learn-more': '了解更多',
	},
	'zh-hant': {
		advertisement: '廣告',
		'learn-more': '閱讀更多',
	},
};
